import React, { useState, useEffect } from 'react'
//card
import { Accordion, AccordionSummary, AccordionDetails , Box, TextField, Grid, Typography, Button} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import IconButton from '@material-ui/core/IconButton';
import genericDataService from '../../../../../services/genericDataService.jsx'
import { Map, TileLayer, Marker } from "react-leaflet";
import { useDebounce } from '../../../../../hooks/useDebounce.jsx';

const AddressAccordion = (props) => {

  const { classes, setAccordionIndex, accordionIndex, user, index, setAlert, readOnly, creating } = props;

  const [edited, setEdited] = useState(false);
  const [address, setAddress] = useState({});
  const [cities, setCities] = useState([]);
  const [searchCity, setSearchCity] = useState("");
  const [citySelected, setCitySelected] = useState({});
  const [firstTimeEdited, setFirstTimeEdited] = useState(false);
  const debounceValue = useDebounce(searchCity, 500);
  const params = {
    q: "",
    format: "json",
    addressdetails: "addressdetails",
  };
  const [state, setState] = useState({
    currentLocation: { lat: 52.52437, lng: 13.41053 },
    zoom: 16,
  });

  const obtenerCoordenadas = async (direccion) => {
    const direccionFormateada = encodeURIComponent(direccion);
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${direccionFormateada}`;

    try {
      const respuesta = await fetch(url);
      if (!respuesta.ok) {
        throw new Error(`Error en la respuesta: ${respuesta.status} ${respuesta.statusText}`);
      }

      const datos = await respuesta.json();

      if (datos.length > 0) {
        const ubicacion = datos[0];
        const latitud = ubicacion.lat;
        const longitud = ubicacion.lon;

        setState({
          ...state,
          currentLocation: { lat: latitud, lng: longitud },
        });

      } else {
        console.error('No se encontraron resultados para la dirección.');
      }
    } catch (error) {
      console.error('Error en la solicitud:', error.message);
    }
  };
  
  const obtenerDireccionDesdeCoordenadas = async (lat, lon) => {
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`;

      const response = await fetch(url);
      const data = await response.json();
      setAddress({
        address: `${data.address?.road ?? ''} ${data.address?.house_number ?? ''}`.trim(),
        city: `${data.address?.road ?? ''} ${data.address?.house_number ?? ''}, ${data.address?.suburb ?? data.address?.city ?? ''}, ${data.address?.state ?? ''}, ${data.address?.country ?? ''}`.trim(),
        postalcode: `${data.address?.postcode?.replace(/\D/g, '') ?? ''}`.trim(),
      });
      setCitySelected(data);

      if(user.address != data.display_name) {
        handleEdited(true);
      } else {
        handleEdited(false);
      }
  };

  const handleMapClick = (e) => {
    const { lat, lng } = e.latlng;

    setState({
      ...state,
      currentLocation: { lat, lng },
    });

    obtenerDireccionDesdeCoordenadas(lat, lng);
  }

  const handleEdited = (value) => {
    if (!creating) setEdited(value);
  }

  useEffect(() => {
    setCitySelected({
      display_name : user.address?.city
    });
    setAddress(user.address);
    
    const cityParts = user.address?.city?.split(', ') ?? ['', '', '', ''];
    if (cityParts.every(part => part.trim() !== '')) {
      obtenerCoordenadas(user.address?.city);
    }
  }, [user]);

  const handleSavePressed = () => {
    const dataService = new genericDataService('addresses')
    if(user.address?.id){
      dataService.update(user.address.id, address)
        .then( res => {
          setEdited(false);
          setAlert({
            severity: 'success',
            message: 'Domicilio actualizado correctamente',
            open: true
          });
        })
        .catch(e => {
          setAlert({
            severity: 'error',
            message: e.message,
            open: true
          });
        });
    } else {
      dataService
        .store({
          ...address,
          user_id: user.id,
        }).then( res => {
          setEdited(false);
          setFirstTimeEdited(true);
          setAlert({
            severity: 'success',
            message: 'Domicilio guardado correctamente',
            open: true});
          })
        .catch((e) => {});
    }
  }

  useEffect(() => {
    if (debounceValue.length > 2) {
        const params = {
            q: debounceValue,
            format: "json",
            addressdetails: 1,
            polygon_geojson: 0,
        };
        const queryString = new URLSearchParams(params).toString();
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
        fetch(`https://nominatim.openstreetmap.org/search?${queryString}`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                setCities(JSON.parse(result));
            })
            .catch((err) => console.log("err: ", err));
    }
  }, [debounceValue]);

  const filterOptions = (options, { inputValue }) => {
    return options;
  };

  return (
    <Accordion
      expanded={accordionIndex === index}
      onChange={(e,v)=>{
        setAccordionIndex(v ? index : -1)
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        IconButtonProps={{color:'secondary'}}
      >
        <Grid container>
          <Grid item xs={11}>
            <Typography variant='h5'>Domicilio</Typography>
          </Grid>
          { edited ?
            <Grid item xs={1}>
            <IconButton onClick={handleSavePressed} aria-label="save-accordion">
              <SaveIcon />
            </IconButton>
          </Grid>
          : <></>}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>       
        <div style={{ width: '100%', height: '700px' }}>
          <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="País"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ required: true }}
                  value={(address?.city?.split(', ')?.[3] ?? '')}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, city: `${address.city?.split(', ')[0] ?? ''}, ${address.city?.split(', ')[1] ?? ''}, ${address.city?.split(', ')[2] ?? ''}, ${e.target.value}`.trim() });
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="Provincia / Estado"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ required: true }}
                  value={(address?.city?.split(', ')?.[2] ?? '')}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, city: `${address.city?.split(', ')[0] ?? ''}, ${address.city?.split(', ')[1] ?? ''}, ${e.target.value}, ${address.city?.split(', ')[3] ?? ''}`.trim() });
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="Ciudad / Barrio"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ required: true }}
                  value={(address?.city?.split(', ')?.[1] ?? '')}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, city: `${address.city?.split(', ')[0] ?? ''}, ${e.target.value}, ${address.city?.split(', ')[2] ?? ''}, ${address.city?.split(', ')[3] ?? ''}`.trim() });
                  }}
                />
              </Grid>
            </Grid>
            
            {/* Grid inferior: Calle y altura, Piso/Manzana, Departamento/N° de casa */}
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="Calle y Altura"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ required: true }}
                  value={(address?.city?.split(', ')?.[0] ?? '')}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, city: `${e.target.value}, ${address.city?.split(', ')[1] ?? ''}, ${address.city?.split(', ')[2] ?? ''}, ${address.city?.split(', ')[3] ?? ''}`.trim() });
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="Piso / Manzana"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ readOnly: readOnly, required: true }}
                  value={(address?.address?.split(', ')?.[1] ?? '').trim()}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, address: `${address.address?.split(',')[0] ?? ''}, ${e.target.value}, ${address.address?.split(',')[2] ?? ''}`.trim() });
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.margin}
                  label="Departamento / N° de casa"
                  size="medium"
                  margin="dense"
                  fullWidth
                  inputProps={{ readOnly: readOnly, required: true }}
                  value={(address?.address?.split(', ')?.[2] ?? '').trim()}
                  onChange={(e) => {
                    handleEdited(true);
                    setAddress({ ...address, address: `${address.address?.split(',')[0] ?? ''}, ${address.address?.split(',')[1] ?? ''}, ${e.target.value}`.trim() });
                  }}
                />
              </Grid>
            </Grid>

            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => {
                const cityParts = address?.city?.split(', ') ?? ['', '', '', ''];
                if (cityParts.every(part => part.trim() !== '')) {
                  obtenerCoordenadas(address?.city);
                }
              }}
            >
              Actualizar mapa
            </Button>

          <Map center={state.currentLocation} zoom={state.zoom} style={{ width: '90%', height: '70%', marginTop: '10px' }} onClick={handleMapClick}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={state.currentLocation}></Marker>
          </Map>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default AddressAccordion;